module.exports = __webpack_public_path__ + "static/img/shou_ye_bg@2x.451febf3.png";